import React, { useEffect } from "react";
import Email from "./items/email";
import Phone from "./items/phone";
import PostalAdress from "./items/postalAdress";
import Website from "./items/website";


const config = require("../../config.json")
const client = config.APP_CLIENT;
const imgName = config.APP_IMG_NAME;
const compagnyName = config.APP_COMPAGNY_NAME;
const compagnyColorPrimary = config.APP_COMPAGNYCOLORPRIMARY;
const colorBackgroundTable = config.APP_COLORBACKGROUNDTABLE;
const widthImage = config.APP_WIDTHIMAGE;

const SignatureStyle = {
  borderSpacing: config.TABLE_SPACING,
  backgroundColor: colorBackgroundTable,
};
const ImageWrapper = {
  width: widthImage,
  height: widthImage,
  marginLeft: "20px",
};
// Removed absolute positioning to avoid Outlook style type issues
const Image = {
  width: widthImage,
  height: "100%",
  margin: "auto",
  display: "block",
};
const ImageObject = {
  width: widthImage,
  height: "100%",
  margin: "auto",
  display: "block",
};
const TextWrapper = {
  fontFamily: "space, Tahoma, sans-serif",
  verticalAlign: "top",
  lineHeight: "1",
  paddingLeft: "5px",
};
const TextWrapperCenter = {
  fontFamily: "space, Tahoma, sans-serif",
  borderRight: `1px solid ${compagnyColorPrimary}`,
  verticalAlign: "top",
  lineHeight: "1",
  paddingRight: "20px",
  paddingLeft: "5px",
};
const UserName = {
  fontSize: "16px",
  margin: "0",
  fontWeight: "700",
  lineHeight: "16px",
  display: "inline-block",
};
const Job = {
  margin: "5px 0px 19px 0px",
  fontSize: "13px",
  color: compagnyColorPrimary,
  fontWeight: "400",
  lineHeight: "13px",
};


const StandardURL = {
  margin: "10px 0px 10px 0px",
  fontSize: "7px",
  fontWeight: "400"
};
const ContainerPartner = {
  marginTop: "15px",
};
const LogoSquare = {
  width: "33px",
  height: "33px",
};


function constructImgUrl(client, ext) {
  if (ext) {
    return `https://files.myclientisrich.com/${client}/${imgName}.${ext}`;
  }
  return "";
}

const SignatureFormatter = ({ user, message, typeImage }) => {

  useEffect(() => {
    document.title = `${compagnyName} | Signature`;
    const metaCharset = document.createElement('meta');
    metaCharset.setAttribute('charSet', 'utf-8');
    document.head.appendChild(metaCharset);
    return () => {
      document.head.removeChild(metaCharset);
    };
  }, [compagnyName]);


  let urlUploadsImg = "";
  if (user.urlImage === "" || user.urlImage === null) {
    if (typeImage === "static") {
      urlUploadsImg = constructImgUrl(client, 'gif');
    } else if (typeImage === "gif") {
      urlUploadsImg = constructImgUrl(client, 'gif');
    }
  }

  const positionImage = message === true ? ImageObject : Image;

  return (
    <div>
      <div className='wrapper-table'>
        <table className="signature" style={SignatureStyle}>
          <tbody>
            <tr>
              {/* LEFT SIDE EMAILS  */}
              <td className="image__wrapper" style={ImageWrapper}>
                {user.urlImage ? (
                  <a style={{ textDecoration: "none", color: "inherit", border: 0 }} href={`https://${user.website}`} target='_blank' rel="noreferrer">
                    <img src={urlUploadsImg} style={{ ...positionImage, border: 0, outline: 0 }} alt="logo" />
                  </a>
                ) : (
                  <a style={{ textDecoration: "none", color: "inherit", border: 0 }} href={`https://${user.website}`} target='_blank' rel="noreferrer">
                    <img src={urlUploadsImg} style={{ ...positionImage, border: 0, outline: 0 }} alt="logo" />
                  </a>
                )}
              </td>

              {/* RIGHT SIDE EMAILS  */}
              <td className="text__wrapper" style={TextWrapperCenter}>
                <table cellPadding="0" cellSpacing="0" style={{borderCollapse: "collapse"}}>
                  <tbody>
                    <tr>
                      <td style={{paddingLeft: "5px"}}>
                        <p style={UserName}>
                          {user.firstname}
                          &nbsp;
                        </p>
                      </td>
                      <td style={{paddingLeft: "5px"}}>
                        <p style={UserName}>
                          {user.lastname}
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table cellPadding="0" cellSpacing="0" style={{borderCollapse: "collapse"}}>
                  <tbody>
                    <tr>
                    <td style={{paddingTop: "5px", paddingLeft: "5px"}}>
                        <p style={Job}>{user.job}</p>
                      </td>
                    </tr>
                  </tbody>
                </table>

                {user.mobile ? (
                  <Phone phone={user.mobile} phoneType="mobile" />
                ) : null}


                {user.phone ? (
                  <Phone phone={user.phone} phoneType="phone" />
                ) : null}

                {user.email ? (
                  <Email email={user.email} />
                ) : null}
              </td>
              <td className="text__wrapper" style={TextWrapper}>

                {user.postalAdress ? (
                  <PostalAdress adress={user.postalAdress} />
                ) : null}
                {user.office_phone ? (
                  <Phone phone={user.office_phone} phoneType="phone" />
                ) : null}

                {user.website ? (
                  <Website website={user.website} />
                ) : null}

                <div style={ContainerPartner}>
                  <a href="https://loeber.fr/entreprise-engagee/nos-certifications/" target="_blank" rel="noreferrer" title="Alsace Excellence">
                    <img style={LogoSquare} src={`https://files.myclientisrich.com/loeber/certifs/alsace-excellence.png`} alt="logo" width="34" height="34" />
                  </a>
                  <a href="https://loeber.fr/entreprise-engagee/nos-certifications/" target="_blank" rel="noreferrer" title="ISO 9001">
                    <img style={LogoSquare} src={`https://files.myclientisrich.com/loeber/certifs/iso9001.png`} alt="logo" width="34" height="34" />
                  </a>
                  <a href="https://loeber.fr/entreprise-engagee/nos-certifications/" target="_blank" rel="noreferrer" title="ISO 45001">
                    <img style={LogoSquare} src={`https://files.myclientisrich.com/loeber/certifs/iso45001.png`} alt="logo" width="34" height="34" />
                  </a>
                  <a href="https://loeber.fr/entreprise-engagee/nos-certifications/" target="_blank" rel="noreferrer" title="ISO 14001">
                    <img style={LogoSquare} src={`https://files.myclientisrich.com/loeber/certifs/iso14001.png`} alt="logo" width="34" height="34" />
                  </a>
                  <a href="https://www.initiativesdurables.com/" target="_blank" rel="noreferrer" title="Initiatives Durables">
                    <img style={LogoSquare} src={`https://files.myclientisrich.com/loeber/certifs/id.png`} alt="logo" width="34" height="34" />
                  </a>
                  <a href="https://loeber.fr/entreprise-engagee/nos-certifications/" target="_blank" rel="noreferrer" title="QualiFelec">
                    <img style={LogoSquare} src={`https://files.myclientisrich.com/loeber/certifs/qualifelec.png`} alt="logo" width="34" height="34"  />
                  </a>
                  <a href="https://loeber.fr/entreprise-engagee/nos-certifications/" target="_blank" rel="noreferrer" title="Ecovadis">
                    <img style={LogoSquare} src={`https://files.myclientisrich.com/loeber/certifs/ecovadis.png`} alt="logo" width="34" height="34" />
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SignatureFormatter;
